import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { ChangeEvent, useCallback } from "react";
import { useMasonryColumns } from "src/context/MasonryLayoutProvider";

const COLUMNS = [1, 2, 3, 4];

const MasonryColumnsSelector = () => {
  const { columns, setColumns } = useMasonryColumns();

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setColumns(Number(event.target.value));
    },
    [setColumns],
  );

  return (
    <Stack direction="row" gap={1} alignItems="center">
      <Typography>Columns</Typography>
      <TextField
        select
        value={columns}
        sx={{ width: 60 }}
        size="small"
        onChange={handleChange}
      >
        {COLUMNS.map((column) => (
          <MenuItem key={column} value={column}>
            {column}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
};

export default MasonryColumnsSelector;
